import styled from 'styled-components'

export const InactiveCourseAlertWrapper = styled.div`
  margin-top: 4px;
  margin-bottom: 16px;
`
